import { ReactLocation, Router } from "@tanstack/react-location";
import React from "react";
import { SDKs } from "~/constants/routes";

// Set up a ReactLocation instance
const location = new ReactLocation();

const LazyLocalContentDeprecated = React.lazy(
  () => import("~/sdks/LocalContentDeprecated")
);
const LazyLocalContent = React.lazy(() => import("~/sdks/LocalContent"));
const LazyLocalDemographics = React.lazy(
  () => import("~/sdks/LocalDemographics")
);

const LazyNeighborhoodHero = React.lazy(
  () => import("~/sdks/NeighborhoodHero")
);
const LazyNeighborhoodMap = React.lazy(() => import("~/sdks/NeighborhoodMap"));
const LazyNeighborhoodCharacteristics = React.lazy(
  () => import("~/sdks/NeighborhoodCharacteristics")
);
const LazyNeighborhoodHighlights = React.lazy(
  () => import("~/sdks/NeighborhoodHighlights")
);
const LazyNeighborhoodDemographics = React.lazy(
  () => import("../sdks/NeighborhoodDemographics")
);
const LazyNeighborhoodPropertyValueDrivers = React.lazy(
  () => import("~/sdks/NeighborhoodPropertyValueDrivers")
);
const LazyNeighborhoodMatch = React.lazy(
  () => import("~/sdks/NeighborhoodMatch")
);
const LazyNeighborhoodMarketTrends = React.lazy(
  () => import("~/sdks/NeighborhoodMarketTrends")
);
const LazyNeighborhoodSchools = React.lazy(
  () => import("~/sdks/NeighborhoodSchools")
);

const LazyNeighborhoodShowcase = React.lazy(
  () => import("~/sdks/NeighborhoodShowcase")
);

const LazyFeaturedNeighborhoods = React.lazy(
  () => import("~/sdks/NeighborhoodFeatured")
);

interface RouteTemplatesProps {
  children: React.ReactNode;
}

const RouteTemplates: React.FC<RouteTemplatesProps> = ({ children }) => {
  const templateRoutes = [
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_CONTENT}`,
      element: <LazyLocalContentDeprecated />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_CONTENT_GOOGLE_MAPS}`,
      element: <LazyLocalContentDeprecated />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_CONTENT_REFRESH}`,
      element: <LazyLocalContent />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_DEMOGRAPHICS}`,
      element: <LazyLocalDemographics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_MAP}`,
      element: <LazyNeighborhoodMap />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_HERO}`,
      element: <LazyNeighborhoodHero />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_CHARACTERISTICS}`,
      element: <LazyNeighborhoodCharacteristics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_HIGHLIGHTS}`,
      element: <LazyNeighborhoodHighlights />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_DEMOGRAPHICS}`,
      element: <LazyNeighborhoodDemographics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_PROPERTY_VALUE_DRIVERS}`,
      element: <LazyNeighborhoodPropertyValueDrivers />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/local-${SDKs.NEIGHBORHOOD_MATCH}`,
      element: <LazyNeighborhoodMatch />,
    },

    // Legacy compatibility. Do NOT remove. Some clients still use this name.
    {
      path: `/sdks-app/${APP_VERSION}/demographics`,
      element: <LazyLocalDemographics />,
    },

    // TODO: LL22-5170 Remove these once the try site has been updated to use the new names
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_MAP}`,
      element: <LazyNeighborhoodMap />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_HERO}`,
      element: <LazyNeighborhoodHero />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_CHARACTERISTICS}`,
      element: <LazyNeighborhoodCharacteristics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_HIGHLIGHTS}`,
      element: <LazyNeighborhoodHighlights />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_DEMOGRAPHICS}`,
      element: <LazyNeighborhoodDemographics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_PROPERTY_VALUE_DRIVERS}`,
      element: <LazyNeighborhoodPropertyValueDrivers />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_MATCH}`,
      element: <LazyNeighborhoodMatch />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_MARKET_TRENDS}`,
      element: <LazyNeighborhoodMarketTrends />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_SCHOOLS}`,
      element: <LazyNeighborhoodSchools />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_SHOWCASE}`,
      element: <LazyNeighborhoodShowcase />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.NEIGHBORHOOD_FEATURED}`,
      element: <LazyFeaturedNeighborhoods />,
    },
  ];

  return (
    <Router location={location} routes={templateRoutes}>
      {children}
    </Router>
  );
};

export default RouteTemplates;
